var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-tasklists" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper page_to_up" },
        [
          _vm.masterAdmin ? _c("masteradmin-sidebar-menu") : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "content-wrapper" }, [
            _c(
              "div",
              { staticClass: "container-wrapper center" },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showOverlay,
                        expression: "showOverlay"
                      }
                    ],
                    staticClass: "modal-custom"
                  },
                  [_vm._m(0)]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form_row" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "form_col_2" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-red btn-md input-height-15",
                        on: {
                          click: function($event) {
                            ;(_vm.isModalVisible = true), _vm.verrors.clear()
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-plus spacer-icon",
                          attrs: { "aria-hidden": "true" }
                        }),
                        _vm._v("Form")
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "heading-seperator",
                  staticStyle: { "margin-top": "2px" }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "margin-bottom-10" }),
                _vm._v(" "),
                _c(
                  "div",
                  {},
                  [
                    _c(
                      "b-navbar",
                      {
                        attrs: {
                          toggleable: "lg",
                          type: "light",
                          variant: "light"
                        }
                      },
                      [
                        _c("b-navbar-brand", { attrs: { href: "#" } }, [
                          _vm._v("Filter/Search")
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-navbar-toggle",
                          { attrs: { target: "nav-collapse" } },
                          [_c("i", { staticClass: "fa fa-chevron-down " })]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-collapse",
                          { attrs: { id: "nav-collapse", "is-nav": "" } },
                          [
                            _c(
                              "div",
                              { staticClass: "search-wrapper col-12" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "row col-12 override-padding"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-lg-3 col-md-12 col-12"
                                      },
                                      [
                                        _c("b-form-input", {
                                          staticClass: "input-text",
                                          attrs: {
                                            type: "text",
                                            placeholder: "Search by Form Name",
                                            maxlength: "255"
                                          },
                                          on: {
                                            keyup: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.filterFormitems()
                                            }
                                          },
                                          model: {
                                            value: _vm.search_keyword,
                                            callback: function($$v) {
                                              _vm.search_keyword = $$v
                                            },
                                            expression: "search_keyword"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-lg-2 col-md-10 col-10"
                                      },
                                      [
                                        _c("b-form-select", {
                                          staticClass: "input-text",
                                          attrs: {
                                            options: _vm.status_options
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.filterFormitems()
                                            }
                                          },
                                          model: {
                                            value: _vm.search_status,
                                            callback: function($$v) {
                                              _vm.search_status = $$v
                                            },
                                            expression: "search_status"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-lg-3 col-md-10 col-10"
                                      },
                                      [
                                        _c("b-form-select", {
                                          staticClass: "input-text",
                                          attrs: {
                                            options: _vm.affiliate_options
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.filterFormitems()
                                            }
                                          },
                                          model: {
                                            value: _vm.search_affiliate,
                                            callback: function($$v) {
                                              _vm.search_affiliate = $$v
                                            },
                                            expression: "search_affiliate"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-lg-2 col-md-12 col-12 padding-lr-5"
                                      },
                                      [
                                        _c("b-form-select", {
                                          staticClass: "input-text",
                                          attrs: { options: _vm.user_options },
                                          on: {
                                            change: function($event) {
                                              return _vm.filterFormitems()
                                            }
                                          },
                                          model: {
                                            value: _vm.search_user,
                                            callback: function($$v) {
                                              _vm.search_user = $$v
                                            },
                                            expression: "search_user"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-lg-1 col-md-2 col-2 search-icon-wrapper cursor-pointer",
                                        on: {
                                          click: function($event) {
                                            return _vm.filterFormitems()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "search-icon" },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-search"
                                            })
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-lg-1 col-md-2 col-2 scroll_box cursor-pointer"
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "scroll_up_down",
                                            on: {
                                              click: function($event) {
                                                return _vm.scrollToElement(
                                                  "down"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa fa-angle-down angle_font"
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "margin-bottom-10" }),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "b-card",
                      { attrs: { "no-body": "" } },
                      [
                        _c("div", { staticClass: "row tasks_heading_row" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 text-left",
                              on: {
                                click: function($event) {
                                  return _vm.sortMethod("name")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                Form\n                "
                              ),
                              _vm.publicSortField == "name" &&
                              _vm.publicSortBy == "ASC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-asc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.publicSortField == "name" &&
                              _vm.publicSortBy == "DESC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-desc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bold cursor-pointer col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1 override-padding text-left",
                              on: {
                                click: function($event) {
                                  return _vm.sortMethod("status")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                Status\n                "
                              ),
                              _vm.publicSortField == "status" &&
                              _vm.publicSortBy == "ASC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-asc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.publicSortField == "status" &&
                              _vm.publicSortBy == "DESC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-desc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bold col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding text-center"
                            },
                            [
                              _vm._v(
                                "\n                # of Fields\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bold col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding text-left"
                            },
                            [
                              _vm._v(
                                "\n                Affiliate\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bold col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding text-left"
                            },
                            [
                              _vm._v(
                                "\n                User Type\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bold cursor-pointer col-xl-1 col-lg-1 col-md-1 col-sm-2 col-2 override-padding text-left",
                              on: {
                                click: function($event) {
                                  return _vm.sortMethod("createdBy")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                Created By\n                "
                              ),
                              _vm.publicSortField == "createdBy" &&
                              _vm.publicSortBy == "ASC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-asc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.publicSortField == "createdBy" &&
                              _vm.publicSortBy == "DESC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-desc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding text-left",
                              on: {
                                click: function($event) {
                                  return _vm.sortMethod("updatedAt")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                   Last Updated\n                   "
                              ),
                              _vm.publicSortField == "updatedAt" &&
                              _vm.publicSortBy == "ASC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-asc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.publicSortField == "updatedAt" &&
                              _vm.publicSortBy == "DESC"
                                ? _c("i", {
                                    staticClass: "fa fa-sort-desc",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.loading,
                                expression: "loading"
                              }
                            ],
                            staticClass: "loading_show"
                          },
                          [
                            _c("div", {
                              staticClass: "spinner-border text-danger"
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _vm.formslists.length > 0
                          ? _c(
                              "b-card-text",
                              [
                                _vm._l(_vm.formslists, function(form, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass: "tasklists-row"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "row tasklist-item",
                                          staticStyle: { margin: "0" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 text-left"
                                            },
                                            [
                                              _vm._v(
                                                "\n                   " +
                                                  _vm._s(form.name) +
                                                  "\n                 "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1 override-padding text-left"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getStatus(form.status)
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "link col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding text-center"
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    form.total_assigned_fields
                                                  ) +
                                                  "\n                    "
                                              ),
                                              form.total_assigned_fields > 0
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-dark-grey in-use-button override-padding",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.viewFormFields(
                                                            form.id
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("View")]
                                                  )
                                                : _vm._e()
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3 override-padding text-left"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(form.affiliate_assigned)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3 override-padding text-left"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(form.roles_assigned)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-xl-1 col-lg-1 col-md-1 col-sm-2 col-2 override-padding text-left"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.truncate(form.created_by)
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "link col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1 override-padding text-center"
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(form.updated_at) +
                                                  "\n                 "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1 override-padding text-left"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "dropdown",
                                                  attrs: {
                                                    id:
                                                      "dropdown-container-" +
                                                      index
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toggleDropdown(
                                                        "actionDropdown_" +
                                                          index +
                                                          ""
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "ul",
                                                    {
                                                      staticClass:
                                                        "dropbtn icons btn-right showLeft",
                                                      attrs: {
                                                        id:
                                                          "dotted-menu" + index
                                                      }
                                                    },
                                                    [
                                                      _c("li"),
                                                      _vm._v(" "),
                                                      _c("li"),
                                                      _vm._v(" "),
                                                      _c("li")
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dropdown-content",
                                                      attrs: {
                                                        id:
                                                          "actionDropdown_" +
                                                          index
                                                      }
                                                    },
                                                    [
                                                      (form.status == "DRAFT" ||
                                                        form.status ==
                                                          "PUBLISH") &&
                                                      _vm.masterAdmin ===
                                                        true &&
                                                      !_vm.$store.state
                                                        .switch_admin_username
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "action-dd-menu",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.goToEdit(
                                                                    form.id
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "cursor-pointer fa fa-edit spacer-icon"
                                                              }),
                                                              _vm._v("Edit")
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      form.status === "DRAFT" &&
                                                      _vm.masterAdmin ===
                                                        true &&
                                                      !_vm.$store.state
                                                        .switch_admin_username
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "action-dd-menu",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.updateFormStatus(
                                                                    form.id,
                                                                    "PUBLISH"
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "cursor-pointer fa fa-upload spacer-icon"
                                                              }),
                                                              _vm._v("Publish")
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      (form.status ===
                                                        "DRAFT" ||
                                                        form.status ===
                                                          "DEACTIVATED") &&
                                                      _vm.masterAdmin ===
                                                        true &&
                                                      !_vm.$store.state
                                                        .switch_admin_username
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "action-dd-menu",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.deleteFormConfirm(
                                                                    form.id
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "cursor-pointer fa fa-times spacer-icon"
                                                              }),
                                                              _vm._v("Remove")
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      form.status == "PUBLISH"
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "action-dd-menu",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.cloneForm(
                                                                    form.id
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "cursor-pointer fa fa-clone spacer-icon"
                                                              }),
                                                              _vm._v("Clone")
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      form.status ==
                                                        "PUBLISH" &&
                                                      _vm.masterAdmin ===
                                                        true &&
                                                      !_vm.$store.state
                                                        .switch_admin_username
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "action-dd-menu",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.deactivateFormConfirm(
                                                                    form.id,
                                                                    form.name
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "cursor-pointer fa fa-eye-slash spacer-icon"
                                                              }),
                                                              _vm._v(
                                                                "Deactivate"
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      form.status ===
                                                        "PUBLISH" &&
                                                      _vm.masterAdmin ===
                                                        true &&
                                                      !_vm.$store.state
                                                        .switch_admin_username
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "action-dd-menu",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.viewAccount(
                                                                    form.id
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "cursor-pointer fa fa-user-o spacer-icon"
                                                              }),
                                                              _vm._v(
                                                                "View account"
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "action-dd-menu",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.previewForm(
                                                                form.id
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "cursor-pointer fa fa-eye spacer-icon"
                                                          }),
                                                          _vm._v("Preview")
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "action-dd-menu",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.getListOfFormFields(
                                                                form.id
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "cursor-pointer fa fa-connectdevelop spacer-icon"
                                                          }),
                                                          _vm._v(
                                                            "Map Form fields to PDF"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      form.status ==
                                                      "DEACTIVATED"
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "action-dd-menu",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.activateFormConfirm(
                                                                    form.id
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "cursor-pointer fa fa-eye-slash spacer-icon"
                                                              }),
                                                              _vm._v("Activate")
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", [_c("hr")])
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "row page_to_down" }, [
                                  _c("div", { staticClass: "mx-auto" }, [
                                    _c(
                                      "div",
                                      { staticClass: "overflow-auto m-3" },
                                      [
                                        _vm.rows > 25
                                          ? _c("b-pagination", {
                                              attrs: {
                                                "total-rows": _vm.rows,
                                                "per-page": _vm.perPage,
                                                "first-text": "First",
                                                "prev-text": "Prev",
                                                "next-text": "Next",
                                                "last-text": "Last",
                                                "hide-goto-end-buttons": true
                                              },
                                              on: {
                                                input: function($event) {
                                                  return _vm.showFormsofPaginated()
                                                }
                                              },
                                              model: {
                                                value: _vm.currentPage,
                                                callback: function($$v) {
                                                  _vm.currentPage = $$v
                                                },
                                                expression: "currentPage"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "page_angle_down" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "scroll_box cursor-pointer"
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "scroll_up_down",
                                              on: {
                                                click: function($event) {
                                                  return _vm.scrollToElement(
                                                    "up"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-angle-up angle_font"
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ],
                              2
                            )
                          : _vm.loading == false
                          ? _c("b-card-text", [
                              _vm._v(
                                "\n                 No Form found.\n            "
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "CreateFormModal",
                  {
                    attrs: { isModalVisible: _vm.isModalVisible },
                    on: {
                      close: function($event) {
                        _vm.isModalVisible = false
                      }
                    }
                  },
                  [
                    _vm.loading
                      ? _c("span", { staticClass: "pull-right text-danger" }, [
                          _vm._v("\n            Loading...\n          ")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "sub-heading",
                        attrs: { slot: "header" },
                        slot: "header"
                      },
                      [_c("h3", [_vm._v("Create Form")])]
                    ),
                    _vm._v(" "),
                    _vm.isModalVisible === true
                      ? _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                          _c(
                            "form",
                            {
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.createForm()
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "col-12 override-padding" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form_name,
                                        expression: "form_name"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    staticClass:
                                      "col-lg-12 input-text form-control",
                                    staticStyle: { "line-height": "30px" },
                                    attrs: {
                                      name: "form_name",
                                      placeholder: "Enter Form Name",
                                      maxlength: "255"
                                    },
                                    domProps: { value: _vm.form_name },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.form_name = $event.target.value
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.verrors.firstByRule(
                                    "form_name",
                                    "required"
                                  )
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "margin-bottom-5 validate-warning-msg"
                                        },
                                        [_vm._v("Form name is required")]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "margin-bottom-10",
                                staticStyle: { clear: "both" }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-12 override-padding" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "search-padd",
                                      attrs: { id: "mentee-group-wrapper" }
                                    },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "font-weight-bold" },
                                        [_vm._v("Affilate: ")]
                                      ),
                                      _vm._v(" "),
                                      _c("multiselect", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        attrs: {
                                          options: _vm.affiliate_options,
                                          "track-by": "text",
                                          label: "text",
                                          placeholder: "Select an Affiliate",
                                          multiple: true,
                                          "close-on-select": false,
                                          "show-labels": false,
                                          name: "affiliate",
                                          id: "affiliate"
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "selection",
                                            fn: function(ref) {
                                              var values = ref.values
                                              var search = ref.search
                                              var isOpen = ref.isOpen
                                              return [
                                                values.length && !isOpen
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "multiselect__single"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            values.length
                                                          ) + " selected"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ]),
                                        model: {
                                          value: _vm.affiliate_selected,
                                          callback: function($$v) {
                                            _vm.affiliate_selected = $$v
                                          },
                                          expression: "affiliate_selected"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.verrors.firstByRule(
                                        "affiliate",
                                        "required"
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "margin-bottom-5 validate-warning-msg"
                                            },
                                            [_vm._v("Affilate is required")]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "margin-bottom-10",
                                staticStyle: { clear: "both" }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-12 override-padding" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "search-padd",
                                      attrs: { id: "mentee-group-wrapper" }
                                    },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "font-weight-bold" },
                                        [_vm._v("Select User Type: ")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.roles_options, function(
                                        userType,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass: "p-1 ml-2"
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.usertypes_selected,
                                                  expression:
                                                    "usertypes_selected"
                                                },
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate"
                                                }
                                              ],
                                              attrs: {
                                                type: "checkbox",
                                                id: "usertype_" + index,
                                                name: "usertype",
                                                "data-vv-rules": "required",
                                                "data-vv-as": "User Type"
                                              },
                                              domProps: {
                                                value: userType.value,
                                                checked: Array.isArray(
                                                  _vm.usertypes_selected
                                                )
                                                  ? _vm._i(
                                                      _vm.usertypes_selected,
                                                      userType.value
                                                    ) > -1
                                                  : _vm.usertypes_selected
                                              },
                                              on: {
                                                change: function($event) {
                                                  var $$a =
                                                      _vm.usertypes_selected,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = userType.value,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.usertypes_selected = $$a.concat(
                                                          [$$v]
                                                        ))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.usertypes_selected = $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                    }
                                                  } else {
                                                    _vm.usertypes_selected = $$c
                                                  }
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                attrs: {
                                                  for: "usertype_" + index
                                                }
                                              },
                                              [_vm._v(_vm._s(userType.name))]
                                            )
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _vm.verrors.firstByRule(
                                        "usertype",
                                        "required"
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "margin-bottom-5 validate-warning-msg"
                                            },
                                            [_vm._v("User Type is required")]
                                          )
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "margin-bottom-10",
                                staticStyle: { clear: "both" }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-12 override-padding text-align-right"
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-sm fmAddBtn",
                                      attrs: { type: "submit" }
                                    },
                                    [_c("b", [_vm._v("Create")])]
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "col-3 override-padding",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "ViewFormFieldsListModal",
                  {
                    attrs: { isModalVisible: _vm.isFormFieldsListModalVisible },
                    on: {
                      close: function($event) {
                        _vm.isFormFieldsListModalVisible = false
                      }
                    }
                  },
                  [
                    _vm.loading
                      ? _c("span", { staticClass: "pull-right text-danger" }, [
                          _vm._v("\n            Loading...\n          ")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "sub-heading",
                        attrs: { slot: "header" },
                        slot: "header"
                      },
                      [
                        _c("div", [
                          _vm._v(
                            "Following fields are associated with this form :"
                          )
                        ]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            class:
                              _vm.assigned_fields.length > 20
                                ? "view-fields-scroll"
                                : ""
                          },
                          _vm._l(_vm.assigned_fields, function(field, fkey) {
                            return _c("li", { key: fkey }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(field.field_name) +
                                  "\n              "
                              )
                            ])
                          }),
                          0
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "body" }, slot: "body" }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "col-3 override-padding",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "DeleteModal",
                  {
                    attrs: {
                      isModalVisible: _vm.isDeleteModalVisible,
                      id: _vm.id
                    },
                    on: {
                      close: function($event) {
                        _vm.isDeleteModalVisible = false
                      }
                    }
                  },
                  [
                    _vm.loading
                      ? _c("span", { staticClass: "pull-right text-danger" }, [
                          _vm._v("\n            Loading...\n          ")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "sub-heading",
                        attrs: { slot: "header" },
                        slot: "header"
                      },
                      [_vm._v("Are you sure you want to delete the form?")]
                    ),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "body" }, slot: "body" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-3 override-padding",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "left col-12 btn btn-red",
                            on: {
                              click: function($event) {
                                _vm.showingdeleteModal = false
                                _vm.deleteForm(_vm.id)
                              }
                            }
                          },
                          [_vm._v("Confirm")]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "DeactivateModal",
                  {
                    attrs: {
                      isModalVisible: _vm.isDeactivateModalVisible,
                      id: _vm.deactivateId
                    },
                    on: {
                      close: function($event) {
                        _vm.isDeactivateModalVisible = false
                      }
                    }
                  },
                  [
                    _vm.loading
                      ? _c("span", { staticClass: "pull-right text-danger" }, [
                          _vm._v("\n            Loading...\n          ")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "sub-heading",
                        attrs: { slot: "header" },
                        slot: "header"
                      },
                      [_vm._v("Are you sure you want to deactivate? ")]
                    ),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "body" }, slot: "body" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-3 override-padding",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "left col-12 btn btn-red",
                            on: {
                              click: function($event) {
                                _vm.showingdeleteModal = false
                                _vm.deactivateForm(_vm.deactivateId)
                              }
                            }
                          },
                          [_vm._v("Confirm")]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "ActivateModal",
                  {
                    attrs: {
                      isModalVisible: _vm.isActivateModalVisible,
                      id: _vm.activateId
                    },
                    on: {
                      close: function($event) {
                        _vm.isActivateModalVisible = false
                      }
                    }
                  },
                  [
                    _vm.loading
                      ? _c("span", { staticClass: "pull-right text-danger" }, [
                          _vm._v("\n            Loading...\n          ")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "sub-heading",
                        attrs: { slot: "header" },
                        slot: "header"
                      },
                      [_vm._v("Are you sure you want to Activate? ")]
                    ),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "body" }, slot: "body" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-3 override-padding",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "left col-12 btn btn-red",
                            on: {
                              click: function($event) {
                                return _vm.activateForm(_vm.activateId)
                              }
                            }
                          },
                          [_vm._v("Confirm")]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "CheckFormValidationModal",
                  {
                    attrs: {
                      isModalVisible: _vm.isDeactivateValidateModalVisible
                    },
                    on: {
                      close: function($event) {
                        _vm.isDeactivateValidateModalVisible = false
                      }
                    }
                  },
                  [
                    _vm.loading
                      ? _c("span", { staticClass: "pull-right text-danger" }, [
                          _vm._v("\n        Loading...\n      ")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "sub-heading",
                        attrs: { slot: "header" },
                        slot: "header"
                      },
                      [
                        _vm._v(
                          'This form "' +
                            _vm._s(_vm.formTitle) +
                            "\" values has been submitted by some users, you can't deactivate this form"
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "body" }, slot: "body" }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "col-3 override-padding",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "MapFormFieldsPdfModalVisible",
                  {
                    attrs: {
                      isModalVisible: _vm.isMapFormFieldsPdfModalVisible,
                      id: _vm.pdfFormId
                    },
                    on: {
                      close: function($event) {
                        return _vm.closeMapFormFieldsPdfModalVisible()
                      }
                    }
                  },
                  [
                    _vm.loading
                      ? _c("span", { staticClass: "pull-right text-danger" }, [
                          _vm._v("\n            Loading...\n            ")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "sub-heading",
                        attrs: { slot: "header" },
                        slot: "header"
                      },
                      [_c("h3", [_vm._v("Map Form fields to PDF:")])]
                    ),
                    _vm._v(" "),
                    _vm.isMapFormFieldsPdfModalVisible === true
                      ? _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                          _vm.isInitial || _vm.isSaving
                            ? _c(
                                "form",
                                {
                                  attrs: {
                                    enctype: "multipart/form-data",
                                    novalidate: ""
                                  },
                                  on: {
                                    submit: function($event) {
                                      $event.preventDefault()
                                      return _vm.saveFormFieldsToPdf(
                                        _vm.pdfFormId
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._l(
                                    _vm.assigned_fields_with_options
                                      .form_fields,
                                    function(field, fIndex) {
                                      return _c(
                                        "div",
                                        { key: fIndex, staticClass: "row p-2" },
                                        [
                                          _c("div", { staticClass: "col-4" }, [
                                            _c("label", [
                                              _vm._v(_vm._s(field.field_name))
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          field.field_type == "text"
                                            ? _c(
                                                "div",
                                                { staticClass: "col-8" },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          field.pdf_field_name,
                                                        expression:
                                                          "field.pdf_field_name"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: "required",
                                                        expression: "'required'"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "col-12 ma-input-field",
                                                    attrs: {
                                                      name:
                                                        "field_pdf_name[" +
                                                        field.field_id +
                                                        "]",
                                                      maxlength: "75"
                                                    },
                                                    domProps: {
                                                      value:
                                                        field.pdf_field_name
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          field,
                                                          "pdf_field_name",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass: "margin-bottom-10",
                                            staticStyle: { clear: "both" }
                                          }),
                                          _vm._v(" "),
                                          _vm._l(field.field_values, function(
                                            fieldVal,
                                            valIndex
                                          ) {
                                            return _c(
                                              "div",
                                              {
                                                key: valIndex,
                                                staticClass:
                                                  "view_field_options row"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "col-4" },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          fieldVal.optionValue
                                                        )
                                                      )
                                                    ])
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "col-8" },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            fieldVal.pdf_field_option_values,
                                                          expression:
                                                            "fieldVal.pdf_field_option_values"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: "required",
                                                          expression:
                                                            "'required'"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "col-12 ma-input-field",
                                                      attrs: {
                                                        name:
                                                          "field_pdf_name[" +
                                                          field.field_id +
                                                          "][" +
                                                          fieldVal.field_option_value_id +
                                                          "]",
                                                        maxlength: "75"
                                                      },
                                                      domProps: {
                                                        value:
                                                          fieldVal.pdf_field_option_values
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            fieldVal,
                                                            "pdf_field_option_values",
                                                            $event.target.value
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.verrors.firstByRule(
                                                  "field_pdf_name[" +
                                                    field.field_id +
                                                    "][" +
                                                    fieldVal.field_option_value_id +
                                                    "]",
                                                  "required"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "pdf_input_error margin-bottom-5 validate-warning-msg"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "PDF Field name is required for " +
                                                            _vm._s(
                                                              fieldVal.optionValue
                                                            )
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          }),
                                          _vm._v(" "),
                                          _vm.verrors.firstByRule(
                                            "field_pdf_name[" +
                                              field.field_id +
                                              "]",
                                            "required"
                                          ) && field.field_values.length == 0
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "pdf_input_error margin-bottom-5 validate-warning-msg"
                                                },
                                                [
                                                  _vm._v(
                                                    "PDF Field name is required for " +
                                                      _vm._s(field.field_name) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "margin-bottom-10",
                                    staticStyle: { clear: "both" }
                                  }),
                                  _vm._v(" "),
                                  !_vm.assigned_fields_with_options
                                    .pdf_filename ||
                                  _vm.assigned_fields_with_options.is_pdf_remove
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-lg-12 col-12 override-padding"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "dropbox" },
                                            [
                                              _c("input", {
                                                ref: "pdf_file",
                                                staticClass: "input-file",
                                                attrs: {
                                                  type: "file",
                                                  name: "pdf_file",
                                                  accept: "type/pdf",
                                                  rules: "required"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _vm.isInitial
                                                ? _c("p", [
                                                    _vm._v(
                                                      "Drag your file here to begin"
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      " or click to browse"
                                                    )
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.isSaving
                                                ? _c("p", [
                                                    _vm._v(
                                                      " Uploading file... "
                                                    )
                                                  ])
                                                : _vm._e()
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.uploadError
                                            ? _c(
                                                "p",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.uploadError)
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-lg-12 col-12 override-padding"
                                        },
                                        [
                                          _c("div", { staticClass: "p-2" }, [
                                            _vm._v(
                                              "Uploaded PDF: \n                        "
                                            ),
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href:
                                                    _vm
                                                      .assigned_fields_with_options
                                                      .pdf_full_path,
                                                  target: "_blank"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm
                                                      .assigned_fields_with_options
                                                      .pdf_filename
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "text-danger float-right",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.removeExistingPdf()
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "cursor-pointer fa fa-times"
                                                })
                                              ]
                                            )
                                          ])
                                        ]
                                      ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "margin-bottom-10",
                                    staticStyle: { clear: "both" }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 override-padding text-align-right"
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-primary btn-sm fmAddBtn",
                                          attrs: { type: "submit" }
                                        },
                                        [_c("b", [_vm._v("Save")])]
                                      )
                                    ]
                                  )
                                ],
                                2
                              )
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "col-3 override-padding",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    })
                  ]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loader-img-center" }, [
      _c("i", { staticClass: "fa fa-spinner fa-spin" }),
      _vm._v(" Please wait...\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form_col_1" }, [
      _c("h3", { staticClass: "d-inline heading" }, [_vm._v("Forms Manager")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25840706", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25840706","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/forms_manager.vue
// module id = null
// module chunks = 